import React from 'react';
import TabbedDashboard from './components/layout/TabbedDashboard';
import { FilterProvider } from './context/FilterContext';
import { ToastProvider } from './components/common/Toast';
import './styles/global.css';

function App() {
    return (
        <ToastProvider>
            <FilterProvider>
                <TabbedDashboard />
            </FilterProvider>
        </ToastProvider>
    );
}

export default App;
